import { useState, useEffect } from "react";
import { highlightHtmlWithShiki } from "../utils/common";

export default function PracticeTitleContent({ title }: { title: string }) {
  const [highlighted, setHighlighted] = useState<string>("");

  useEffect(() => {
    highlightHtmlWithShiki(title).then(setHighlighted);
  }, [title]);

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: highlighted,
      }}
    />
  );
}
